import React from "react";
import DocumentationSidebar from "../component/DocumentationSidebar";
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';


export default function SurveyGroups() {
  const { t } = useTranslation();
  const image01 = useDocImage('survey-groups-img', 'image1.png');
  const image02 = useDocImage('survey-groups-img', 'image 2.png');
  const image03 = useDocImage('survey-groups-img', 'image3.png');
  const image04 = useDocImage('survey-groups-img', 'image4.png');
  const image05 = useDocImage('survey-groups-img', 'image5.png');
  const image06 = useDocImage('survey-groups-img', 'image6.png');
  const image07 = useDocImage('survey-groups-img', 'image7.png');
  const image08 = useDocImage('survey-groups-img', 'image8.png');
  const image09 = useDocImage('survey-groups-img', 'image9.png');

  return (
    <div className="d-flex flex-column main-outer-wrapper">
      <div className="flex-grow-1 d-flex survey-main-wrapper">
        <DocumentationSidebar />

        {/* Page Content */}
        <div className="flex-grow-1 dashboard-page-outer">
          <div className="dashboard-page-wrap document-page-wrap">
            <h1 className="mt-0 text-primary">{t('documentation.surveyGroups.title')}</h1>
            <p className="header-para">{t('documentation.surveyGroups.intro')}</p>

          
            {/* 1. Creating and Managing Survey Groups */}
            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.surveyGroups.createGroup.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.surveyGroups.createGroup.beforeStart')}</p>

                {/* CREATE GROUP */}
                <p><b>{t('documentation.surveyGroups.createGroup.createTitle')}</b></p>
                <ol>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.steps.step1')}
                  </li>

                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.steps.step2')}
                  </li>

                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.steps.step3')}
                  </li>

                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.steps.step4')}
                  </li>

                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.steps.step5')}
                  </li>

                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.steps.step6')}
                  </li>

                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.steps.step7')}
                  </li>
                </ol>

            <img src={image01} alt={t('documentation.surveyGroups.createGroup.imageAlt1')} className='img-fluid pb-20 pt-20' />


                 <p className="mt-3"><b>{t('documentation.surveyGroups.createGroup.listFieldsTitle')}</b></p>
                 <ul>
                   <li>
                     {t('documentation.surveyGroups.createGroup.listFields.groupName')}
                   </li>
                   <li>
                     {t('documentation.surveyGroups.createGroup.listFields.totalSurveys')}
                   </li>
                   <li>
                     {t('documentation.surveyGroups.createGroup.listFields.addedOn')}
                   </li>
                   <li>
                     {t('documentation.surveyGroups.createGroup.listFields.action')}
                     <ul className="pt-2">
                       <li>{t('documentation.surveyGroups.createGroup.listFields.actionItems.rename')}</li>
                       <li>{t('documentation.surveyGroups.createGroup.listFields.actionItems.delete')}</li>
                     </ul>
                   </li>
                 </ul>

             

                {/* RENAME GROUP */}
                <p className="mt-4"><b>{t('documentation.surveyGroups.createGroup.renameTitle')}</b></p>
                <ol>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.renameSteps.step1')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.renameSteps.step2')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.renameSteps.step3')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.renameSteps.step4')}
                  </li>
                </ol>

                {/* DELETE GROUP */}
                <p className="mt-4"><b>{t('documentation.surveyGroups.createGroup.deleteTitle')}</b></p>
                <ol>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.deleteSteps.step1')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.deleteSteps.step2')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.deleteSteps.step3')}
                    <ul>
                      <li>{t('documentation.surveyGroups.createGroup.deleteItems.item1')}</li>
                      <li>{t('documentation.surveyGroups.createGroup.deleteItems.item2')}</li>
                      <li>{t('documentation.surveyGroups.createGroup.deleteItems.item3')}</li>
                    </ul>
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.createGroup.deleteSteps.step4')}
                  </li>
                </ol>
                <img src={image02} alt={t('documentation.surveyGroups.createGroup.imageAlt2')} className='img-fluid pb-20 pt-20' />

              </div>
            </div>

            {/* 2. Managing Surveys in a Group */}
            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.surveyGroups.manageGroup.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.surveyGroups.manageGroup.intro')}</p>

                {/* ADDING SURVEYS */}
                <p><b>{t('documentation.surveyGroups.manageGroup.addSurveysTitle')}</b></p>
                <ol>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.addSurveysSteps.step1')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.addSurveysSteps.step2')}
                    <ul className="pt-2">
                      <li>{t('documentation.surveyGroups.manageGroup.addSurveysSteps.step2Items.item1')}</li>
                      <li>{t('documentation.surveyGroups.manageGroup.addSurveysSteps.step2Items.item2')}</li>
                    </ul>
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.addSurveysSteps.step3')}
                    <ul className="pt-2">
                      <li>{t('documentation.surveyGroups.manageGroup.addSurveysSteps.step3Items.item1')}</li>
                    </ul>
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.addSurveysSteps.step4')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.addSurveysSteps.step5')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.addSurveysSteps.step6')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.addSurveysSteps.step7')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.addSurveysSteps.step8')}
                  </li>
                </ol>
              <img src={image03} alt={t('documentation.surveyGroups.manageGroup.imageAlt3')} className='img-fluid pb-20 pt-20' />

                <p className="mt-4"><b>{t('documentation.surveyGroups.manageGroup.manageTitle')}</b></p>
                <p>{t('documentation.surveyGroups.manageGroup.manageIntro')}</p>
                <ol>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.manageSteps.step1')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.manageSteps.step2')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.manageSteps.step3')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.manageSteps.step4')}
                    <ul className="pt-2">
                      <li>{t('documentation.surveyGroups.manageGroup.manageSteps.step4Items.item1')}</li>
                      <li>{t('documentation.surveyGroups.manageGroup.manageSteps.step4Items.item2')}</li>
                    </ul>
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.manageSteps.step5')}
                    <ul>
                   <li>
                     {t('documentation.surveyGroups.manageGroup.manageSteps.fields.surveyName')}
                   </li>
                   <li>
                     {t('documentation.surveyGroups.manageGroup.manageSteps.fields.completion')}
                   </li>
                   <li>
                     {t('documentation.surveyGroups.manageGroup.manageSteps.fields.language')}
                   </li>
                   <li>
                     {t('documentation.surveyGroups.manageGroup.manageSteps.fields.status')}
                   </li>
                   <li>
                     {t('documentation.surveyGroups.manageGroup.manageSteps.fields.assignTeam')}
                   </li>
                   <li>
                     {t('documentation.surveyGroups.manageGroup.manageSteps.fields.addedOn')}
                   </li>
                   <li>
                     {t('documentation.surveyGroups.manageGroup.manageSteps.fields.responses')}
                   </li>
                   <li>
                     {t('documentation.surveyGroups.manageGroup.manageSteps.fields.publishedOn')}
                   </li>
                   <li>
                     {t('documentation.surveyGroups.manageGroup.manageSteps.fields.action')}
                     <ul className="pt-2">
                       <li>{t('documentation.surveyGroups.manageGroup.manageSteps.fields.actionItems.primary')}</li>
                       <li>{t('documentation.surveyGroups.manageGroup.manageSteps.fields.actionItems.viewLeads')}</li>
                       <li>{t('documentation.surveyGroups.manageGroup.manageSteps.fields.actionItems.remove')}</li>
                     </ul>
                   </li>
                 </ul>
                  </li>
                  <img src={image04} alt={t('documentation.surveyGroups.manageGroup.imageAlt4')} className='img-fluid pb-20 pt-20' />
                </ol>

                <p className="mt-4"><b>{t('documentation.surveyGroups.manageGroup.utmTitle')}</b></p>
                <p>{t('documentation.surveyGroups.manageGroup.utmIntro')}</p>
                <ol>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.utmSteps.step1')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.utmSteps.step2')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.utmSteps.step3')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.utmSteps.step4')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.utmSteps.step5')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.utmSteps.step6')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.manageGroup.utmSteps.step7')}
                  </li>
                  <img src={image05} alt={t('documentation.surveyGroups.manageGroup.imageAlt5')} className='img-fluid pb-20 pt-20' />
                </ol>

             




                {/* <img src={image002} alt="Add Surveys to Group" className="img-fluid pt-20 pb-20" /> */}

                
                {/* <img src={image003} alt="Reorder Surveys" className="img-fluid pt-20 pb-20" /> */}

              

              </div>
            </div>

            {/* 3. Survey Group Links & UTM Variables */}
            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.surveyGroups.links.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.surveyGroups.links.intro')}</p>

                 <p><b>{t('documentation.surveyGroups.links.basicTitle')}</b></p>
                 <ol>
                   <li className="mb-2">
                     {t('documentation.surveyGroups.links.basicSteps.step1')}
                   </li>
                   <li className="mb-2">
                     {t('documentation.surveyGroups.links.basicSteps.step2')}
                   </li>
                   <li className="mb-2">
                     {t('documentation.surveyGroups.links.basicSteps.step3')}
                   </li>
                   <img src={image07} alt={t('documentation.surveyGroups.links.imageAlt6')} className='img-fluid pb-20 pt-20' />
                 </ol>

                 {/* <img src={image004} alt="Share Survey Group Link" className="img-fluid pt-20 pb-20" /> */}

                 

                <p><b>{t('documentation.surveyGroups.links.campaignTitle')}</b></p>
                <p>{t('documentation.surveyGroups.links.campaignIntro')}</p>
                <ol>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.links.campaignSteps.step1')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.links.campaignSteps.step2')}
                    <ul>
                      <li>{t('documentation.surveyGroups.links.campaignSteps.fields.name')}</li>
                      <li>{t('documentation.surveyGroups.links.campaignSteps.fields.source')}</li>
                      <li>{t('documentation.surveyGroups.links.campaignSteps.fields.medium')}</li>
                      <li>{t('documentation.surveyGroups.links.campaignSteps.fields.campaign')}</li>
                      <li>{t('documentation.surveyGroups.links.campaignSteps.fields.content')}</li>
                    </ul>
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.links.campaignSteps.step3')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.links.campaignSteps.step4')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.links.campaignSteps.step5')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.links.campaignSteps.step6')}
                  </li>
                   <img src={image06} alt={t('documentation.surveyGroups.links.imageAlt7')} className='img-fluid pb-20 pt-20' />
                </ol>


                <p><b>{t('documentation.surveyGroups.links.whatHappensTitle')}</b></p>
                 <ul>
                   <li className="mb-2">
                     {t('documentation.surveyGroups.links.whatHappensItems.item1')}
                   </li>
                   <li className="mb-2">
                     {t('documentation.surveyGroups.links.whatHappensItems.item2')}
                   </li>
                   <li className="mb-2">
                     {t('documentation.surveyGroups.links.whatHappensItems.item3')}
                   </li>
                    <img src={image08} alt={t('documentation.surveyGroups.links.imageAlt8')} className='img-fluid pb-20 pt-20' />
                 </ul>

               
              </div>
            </div>

            

            {/* 5. Analytics for Survey Groups */}
            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.surveyGroups.analytics.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.surveyGroups.analytics.intro')}</p>

                <p><b>{t('documentation.surveyGroups.analytics.accessTitle')}</b></p>
                <ol>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.analytics.accessSteps.step1')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.analytics.accessSteps.step2')}
                    <ul>
                      <li>{t('documentation.surveyGroups.analytics.accessSteps.step2Items.item1')}</li>
                      <li>{t('documentation.surveyGroups.analytics.accessSteps.step2Items.item2')}</li>
                    </ul>
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.analytics.accessSteps.step3')}
                  </li>
                </ol>

                <p><b>{t('documentation.surveyGroups.analytics.whatYouSeeTitle')}</b></p>
                <ul>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.analytics.combined')}
                  </li>
                  <li className="mb-2">
                    {t('documentation.surveyGroups.analytics.byLanguageTitle')}
                    <ul>
                      <li>{t('documentation.surveyGroups.analytics.byLanguageItems.item1')}</li>
                      <li>{t('documentation.surveyGroups.analytics.byLanguageItems.item2')}</li>
                      <li>{t('documentation.surveyGroups.analytics.byLanguageItems.item3')}</li>
                    </ul>
                  </li>
                 <img src={image09} alt={t('documentation.surveyGroups.analytics.imageAlt9')} className='img-fluid pb-20 pt-20' />
                  
                </ul>

            
               
              </div>
            </div>

            

          </div>
        </div>
      </div>
    </div>
  );
}


